import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=55b7cc76&scoped=true&"
import script from "./TextComponent.vue?vue&type=script&lang=js&"
export * from "./TextComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TextComponent.vue?vue&type=style&index=1&id=55b7cc76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7cc76",
  null
  
)

export default component.exports